export default __webpack_public_path__ + "static/media/bg-pattern-circles.bae804b8.svg";